import React from 'react';
import { Loader } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import styles from '../PostPurchaseStep.scss';

export function PostPurchaseLoadingScreen() {
  const { t } = useTranslation();

  return (
    <div className={styles.postPurchaseAccessState} role="status" aria-label={t('post_purchase.loading.aria')}>
      <Loader size="large" />
    </div>
  );
}
